export const ErrorCode = {
  unauthorized: 'unauthorized',
  forbidden: 'forbidden',
  inactiveUserLogin: 'inactiveUserLogin',
  unverifiedUserLogin: 'unverifiedUserLogin',
  unprocessable: 'unprocessable',
  badRequest: 'badRequest',
  notFound: 'notFound',
  validationError: 'validationError',
  referentialIntegrity: 'referentialIntegrity',
  orgUserExists: 'orgUserExists',
  invalidPassword: 'invalidPassword',
  failedToCreateUser: 'failedToCreateUser',
  ambiguousUserLookup: 'ambiguousUserLookup',
  multipleUsersFound: 'multipleUsersFound',
  multipleAccountsFound: 'multipleAccountsFound',
  invalidJwt: 'invalidJwt',
  accountExists: 'accountExists',
  accountExistsInactive: 'accountExistsInactive',
  missingThreadedCallable: 'missingThreadedCallable',
  upstreamUnavailable: 'upstreamUnavailable',
};